import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <SEO
        title="404 — Page Not Found | Techie Interiors"
        description="The page you are looking for does not exist or has been moved."
        url="https://techieinteriors.co.ke/404"
        noindex
      />
      <div className="not-found-inner">
        <h1>404 — Page not found</h1>
        <p>Sorry, we could not find that page.</p>
        <Link to="/">Back to home</Link>
      </div>
    </div>
  );
};

export default NotFound;
